import { isArray, isString } from 'lodash-es'

interface AuthData {
  permissionList: string[] | null
  roleList: string[] | null
}

let AUTH_DATA: AuthData

export const AuthConfig = {
  setAuthData(data: AuthData) {
    AUTH_DATA = data
  },
}

export const p = (permission: string | string[], type?: 'and' | 'or') => {
  if (isString(permission)) {
    return hasPermission(permission)
  } else if (isArray(permission)) {
    if (type == 'and') {
      return hasPermissionAnd(permission)
    } else {
      return hasPermissionOr(permission)
    }
  }

  return false
}

export const r = (role: string | string[], type?: 'and' | 'or') => {
  if (isString(role)) {
    return hasRole(role)
  } else if (isArray(role)) {
    if (type == 'and') {
      return hasRoleAnd(role)
    } else {
      return hasRoleOr(role)
    }
  }

  return false
}

export function hasPermission(permission: string) {
  if (!AUTH_DATA || !AUTH_DATA.permissionList) {
    return false
  }

  return AUTH_DATA.permissionList.indexOf(permission) > -1
}

export function hasPermissionAnd(permissions: string[]) {
  for (let i = 0; i < permissions.length; i++) {
    if (!hasPermission(permissions[i])) {
      return false
    }
  }

  return true
}

export function hasPermissionOr(permissions: string[]) {
  for (let i = 0; i < permissions.length; i++) {
    if (hasPermission(permissions[i])) {
      return true
    }
  }

  return false
}

export function hasRole(role: string) {
  if (!AUTH_DATA || !AUTH_DATA.roleList) {
    return false
  }

  return AUTH_DATA.roleList.indexOf(role) > -1
}

export function hasRoleAnd(roles: string[]) {
  for (let i = 0; i < roles.length; i++) {
    if (!hasRole(roles[i])) {
      return false
    }
  }

  return true
}

export function hasRoleOr(roles: string[]) {
  for (let i = 0; i < roles.length; i++) {
    if (hasPermission(roles[i])) {
      return true
    }
  }

  return false
}
